module.exports = __webpack_public_path__ + "img/WQ.2fc82c3c.svg";